/*
 * @Description:
 * @Author: HG
 * @Date: 2019-08-21 13:38:08
 * @LastEditors: HG
 * @LastEditTime: 2019-09-26 11:22:47
 */
import Vue from "vue";
import OnAccountComponent from "./OnAccount.vue";

const OnAccount = Vue.extend(OnAccountComponent);

// const instances = [];
//let seed = 1;
const OnAccountModal = options => {
  if (Vue.prototype.$isServer) return;

  const {
    //autoClose,
    ...rest
  } = options;
  const instance = new OnAccount({
    propsData: {
      ...rest
    },
    data: {
      //autoClose: autoClose === undefined ? 3000 : autoClose
    }
  });

  const id = `SelectPicker`;
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;

  instance.vm.$on("update", param => {
    if (instance.update) {
      instance.update(param);
    }
  });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};

export { OnAccountModal };
